
import SetLanguage from "../Common/SetLanguage";

const SelectLanguage = ({ modalSelectLanguage, setModalSelectLanguage }) => {    
    return (
        <div className={modalSelectLanguage ? "modal-sheet active" : "modal-sheet"}>
            <div className="modal-sheet-content bottomSheet-content">
                <div className="modal-sheet-body">
                    <div className="d-flex justify-content-center" onClick={() => setModalSelectLanguage(false)}>
                        <SetLanguage />
                    </div>
                </div>
            </div>
            <div className="modal-sheet-back" onClick={() => setModalSelectLanguage(false)}>
            </div>
        </div>
    );
}

export default SelectLanguage;